module.exports = __webpack_public_path__ + "img/16.ffa8b8f1.png";